export default class EmrComponentsModule {
    provides() {
        return {
            EmrRoutes: [() => require('./routes').default],
        };
    }

}
